






































































import { AxiosResponse } from "node_modules/axios";
import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Member, ToggleTeamMemberStatusPayload } from "../types";
import { translateRole } from "../utils";

const Team = namespace("team");

@Component({
  components: {},
  filters: {
    translateRole,
  },
})
export default class DeleteTeamMember extends Vue {
  @Team.Action("fetchMembers") fetchMembers!: () => Promise<{}>;
  @Team.Action("fetchCurrentTeamMember") fetchCurrentTeamMember!: (
    memberId?: string
  ) => Promise<{}>;
  @Team.Action("toggleTeamMemberStatus") toggleTeamMemberStatus!: (
    payload: ToggleTeamMemberStatusPayload
  ) => Promise<AxiosResponse>;
  @Team.Getter("getCurrentTeamMember") currentTeamMember: Member;

  loading = false;
  hasErrors = false;
  async beforeMount() {
    const { memberId } = this.$route.params;
    await this.fetchCurrentTeamMember(memberId);
  }
  goBack() {
    this.$router.push({ name: "team" });
  }
  confirm() {
    this.loading = true;
    const { memberId } = this.$route.params;

    this.toggleTeamMemberStatus({
      action: this.action(),
      memberId,
    })
      .then(() => {
        this.loading = false;
        this.$notify({
          group: "success",
          title: "Success",
          text: "Team member disabled successfully.",
        });
        this.fetchMembers();
        this.goBack();
      })
      .catch(() => {
        this.loading = false;
        this.$notify({
          group: "error",
          title: "Error",
          text: "Failed to disable team member.",
        });
      });
  }

  action(): string {
    return this.currentTeamMember.disabled ? "Enable" : "Disable";
  }
}
